<div class="modal-header">
    <h4 class="modal-title fw-bold">
        @if (oauthClient.id) {
            <span jhiTranslate="site-admin.oauth-clients.edit.title">Edit OAuth Client</span>
        } @else {
            <span jhiTranslate="site-admin.oauth-clients.add.title">Add OAuth Client</span>
        }
    </h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="clear()">
    </button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col">
            <div class="alert alert-info" jhiTranslate="site-admin.oauth-clients.client.id.and.redirect.uri.explanation">
            </div>
        </div>
    </div>
    <form name="form" #f="ngForm" class="form-horizontal">
        <div class="mb-3 row required">
            <label class="col-sm-4 col-form-label fw-bold" jhiTranslate="site-admin.oauth-clients.pane.table.column.client.name">Client ID</label>
            <div class="col-sm-8">
                <input type="text" class="form-control" name="clientName"
                       #clientName="ngModel"
                       [(ngModel)]="oauthClient.clientId"
                       jhi-forbiddenCharactersValidator
                       required
                       minlength="3"
                       maxlength="50"
                       [class.is-invalid]="clientName.invalid && (clientName.dirty || clientName.touched)"/>
                <div *ngIf="clientName.invalid && (clientName.dirty || clientName.touched)" class="invalid-feedback">
                    <div *ngIf="clientName.errors?.['required']" jhiTranslate="site-admin.oauth-clients.validation.client.name.required">Client ID is required.</div>
                    <div *ngIf="clientName.errors?.['minlength']" jhiTranslate="site-admin.oauth-clients.validation.client.name.minlength">Client ID must be at least 3 characters.</div>
                    <div *ngIf="clientName.errors?.['maxlength']" jhiTranslate="site-admin.oauth-clients.validation.client.name.maxlength">Client ID must not exceed 50 characters.</div>
                </div>
            </div>
        </div>
        <div class="mb-3 row required">
            <label class="col-sm-4 col-form-label fw-bold" jhiTranslate="site-admin.oauth-clients.pane.table.column.redirect.uri">Redirect URI</label>
            <div class="col-sm-8">
                <input type="url" class="form-control" name="redirectUri"
                       #redirectUri="ngModel"
                       [(ngModel)]="oauthClient.redirectUri"
                       jhi-forbiddenCharactersValidator
                       required
                       maxlength="1024"
                       pattern="^(https://[a-zA-Z0-9][a-zA-Z0-9\-\.]*\.[a-zA-Z]{2,}(:[0-9]+)?(/[^\s]*)?|http://localhost(:[0-9]+)?(/[^\s]*)?|http://127\.0\.0\.1(:[0-9]+)?(/[^\s]*)?|[a-zA-Z][a-zA-Z0-9+\-.]*://[^\s]*)$"
                       [class.is-invalid]="redirectUri.invalid && (redirectUri.dirty || redirectUri.touched)"/>
                <div *ngIf="redirectUri.invalid && (redirectUri.dirty || redirectUri.touched)" class="invalid-feedback">
                    <div *ngIf="redirectUri.errors?.['required']" jhiTranslate="site-admin.oauth-clients.validation.redirect.uri.required">Redirect URI is required.</div>
                    <div *ngIf="redirectUri.errors?.['pattern']" jhiTranslate="site-admin.oauth-clients.validation.redirect.uri.pattern">Redirect URI must be a valid URL (https required; http allowed for localhost only).</div>
                    <div *ngIf="redirectUri.errors?.['maxlength']" jhiTranslate="site-admin.oauth-clients.validation.redirect.uri.maxlength">Redirect URI must not exceed 200 characters.</div>
                </div>
            </div>
        </div>
        <div class="mb-3 row">
            <label class="col-sm-4 col-form-label fw-bold" jhiTranslate="site-admin.oauth-clients.pane.table.column.description">Description</label>
            <div class="col-sm-8">
                <input type="text" class="form-control" name="description"
                       #description="ngModel"
                       [(ngModel)]="oauthClient.description"
                       jhi-forbiddenCharactersValidator
                       maxlength="200"
                       [class.is-invalid]="description.invalid && (description.dirty || description.touched)"/>
                <div *ngIf="description.invalid && (description.dirty || description.touched)" class="invalid-feedback">
                    <div *ngIf="description.errors?.['maxlength']" jhiTranslate="site-admin.oauth-clients.validation.description.maxlength">Description must not exceed 200 characters.</div>
                </div>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button (click)="clear()" type="button" class="btn btn-secondary" value="Cancel">
        <span class="fa fa-ban"></span>&nbsp;{{ 'cancel' | translate }}
    </button>
    <button (click)="save()" [disabled]="!isFormValid(f) || isLoading" class="btn btn-primary">
        <span *ngIf="isLoading" class="throbber throbber-btn"></span>
        <span class="fa fa-save"></span>&nbsp;
        <span jhiTranslate="save"></span>
    </button>
</div>
